import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Box, MenuItem, TextField } from '@mui/material'

import { useTransactionsFilters } from '@/views/transactions/hooks/use-transactions-filters.hooks'
import { TransactionType } from '@/enums/transaction-type.enum'
import { mapEnum } from '@/utils'

export const TransactionsFilters = () => {
  const { t } = useTranslation()

  const { filters, handleChangeSearch } = useTransactionsFilters()

  const transactionsOptions = mapEnum(
    TransactionType,
    (index: TransactionType) => {
      return (
        <MenuItem key={index} value={index}>
          {t(
            `transaction.transactionType.${
              TransactionType[index as TransactionType]
            }`,
          )}
        </MenuItem>
      )
    },
  )

  return (
    <Grid container spacing={1} alignItems="flex-end">
      <Grid item xs={12} md={4} lg={2}>
        <TextField
          fullWidth
          name="transactionType"
          label={t('roles')}
          id="transactionType"
          value={filters?.transactionType || ''}
          onChange={(event: React.ChangeEvent<any>) =>
            handleChangeSearch({ transactionType: event.target.value })
          }
          select
        >
          <MenuItem value="">
            <Box fontStyle="italic">{t('all')}</Box>
          </MenuItem>
          {transactionsOptions}
        </TextField>
      </Grid>
    </Grid>
  )
}
